import script from "./NoResultFound.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoResultFound.vue?vue&type=script&setup=true&lang=ts"

import "./NoResultFound.vue?vue&type=style&index=0&id=a880b25a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a880b25a"]])

export default __exports__